$(window).load ->
	$home = $ 'body.home'
	unless $home.length > 0
		return

	$slider = $ '.slider'
	$navs = $slider.find '.slider-nav_i'
	$slides = $slider.find '.slide'
	$slidesWrapper = $slider.find '.slides'
	$arrows = $slider.find '.arrow'
	$underline = $slider.find '.slider-nav_i.__underline'
	$scrollLogo = $ '.scroll-logo'
	$document = $ document
	$window = $ window

	$slider.on 'change', (e, index) ->
		return if $slider.currentIndex is index

		length = $slides.length
		last = length - 1

		if index is 'next'
			index = $slider.currentIndex + 1
			direction = 'right'
		else if index is 'prev'
			index = $slider.currentIndex - 1
			direction = 'left'

		if index < 0
			index = last
		if index > last
			index = 0

		$slider.currentIndex = index
		$nav = $navs.eq index
		$nextSlide = $slides.eq index
		$nextSlideContent = $nextSlide.find '.content'
		$nextSlideImg = $nextSlide.find 'img'
		$currentSlide = $slides.filter '.is-current'

		if $currentSlide.length > 0
			$currentContent = $currentSlide.find '.content'
			$currentImg = $currentSlide.find 'img'

			offsetLeft = $slidesWrapper.offset().left
			currentIndex = $currentSlide.index()
			direction = direction || if index > currentIndex then 'right' else 'left'
			backgroundPosition = index * 15 + '%'

			$slider.stop(true).animate backgroundPositionX: backgroundPosition
			$currentImg.stop(true).fadeOut()
			$currentContent.stop(true).animate
				left: if direction is 'left' then offsetLeft else -offsetLeft
				opacity: 0
			, ->
				$slides.removeClass 'is-current'
				$nextSlide.addClass 'is-current'

				$nextSlideContent
					.stop true
					.css
							left: if direction is 'left' then -offsetLeft else offsetLeft
					.animate
							left: 0
							opacity: 1
					, ->
						$nextSlideImg.stop(true).fadeIn()
		else
			$nextSlide.addClass 'is-current'
			$nav.addClass 'is-current'
			$nextSlideContent.css 'opacity', 1
			$nextSlideImg.fadeIn()

		navWidth = $nav.width()
		marginLeft = $nav.css 'margin-left'
		left = $nav.position().left + parseInt(marginLeft)

		$navs.removeClass 'is-current'
		$nav.addClass 'is-current'

		$underline.stop(true).animate
			width: navWidth
			left: left

	$navs.on 'click', ->
		$this = $ this
		index = $this.index()
		$slider.trigger 'change', index

	$arrows.on 'click', ->
		$this = $ this
		left = $this.hasClass 'is-left'
		direction = if left then 'prev' else 'next'

		$slider.trigger 'change', direction

	$slider.trigger 'change', 0

	timer = null
	$slider.hover ->
		clearInterval timer
	, ->
		timer = setInterval ->
			$slider.trigger 'change', 'next'
		, 5000

	scrolllogoOffset = $scrollLogo.offset().top
	windowHalfHeight = $window.height() / 2

	$window.resize ->
		windowHalfHeight = $window.height() / 2

	$document.on 'scroll', ->
		scrollTop = $document.scrollTop() + windowHalfHeight

		if scrollTop > scrolllogoOffset
			$scrollLogo.addClass '-scroll' unless $scrollLogo.hasClass '-scroll'
		else
			$scrollLogo.removeClass '-scroll' if $scrollLogo.hasClass '-scroll'
	.trigger 'scroll'


/** WEBPACK FOOTER **
 ** ./assets/coffee/pages/home.coffee
 **/